"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.mutatorAction('toggleThemeQuickOptionExpansion', function toggleThemeQuickOptionExpansion(overrideValue) {
    var themeOptions = store_1.default();
    themeOptions.isQuickOptionExpanded =
        overrideValue === void 0 ? !themeOptions.isQuickOptionExpanded : overrideValue;
});
//# sourceMappingURL=toggleThemeQuickOptionExpansion.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-theme-option/lib/data/mutators/toggleThemeQuickOptionExpansion.js
// module id = 4966
// module chunks = 2